import classNames from 'classnames';
import Lottie from '@/shared/components/shared/Lottie';
import Image from '../../shared/Image';
import { DEFAULT_ECOSYSTEM_ITEMS } from '../EcosystemSection/ecosystem-data';

const LIVE_ECOSYSTEM_ITEM = DEFAULT_ECOSYSTEM_ITEMS[2];

export type IconTextSectionProps = {
    text: string;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    iconTextSectionProps: IconTextSectionProps;
};

const IconTextSection = ({ iconTextSectionProps, ...props }: Props) => {
    return (
        <section
            {...props}
            className={classNames('icon-text-section js-header-theme-trigger', props.className)}
            data-theme="dark"
        >
            <div className="icon-text-section__bg" aria-hidden="true">
                <Image src="/img/live/hero-circles.png" alt="" width={3840} height={2160} sizes="1940px" priority />
            </div>
            <div className="icon-text-section__wrapper wrapper">
                <div className="icon-text-section__icon" aria-hidden="true">
                    <div className="ecosystem-section__pictogram">
                        <Lottie
                            src={LIVE_ECOSYSTEM_ITEM.lottie.src}
                            className="ecosystem-section__pictogram-img img-fluid"
                        />
                    </div>
                </div>
                <div
                    className="icon-text-section__text h2 wysiwyg"
                    dangerouslySetInnerHTML={{ __html: iconTextSectionProps.text }}
                />
            </div>
        </section>
    );
};

export default IconTextSection;
